import React from "react";
import copperscrap from "../Images/copperscrap.png";
import SEO from "../Components/SEO";

const CopperHero = () => {
  return (
    <>
      <SEO 
        title="Copper Scrap Recycling & Supply" 
        description="Recycle copper scrap, copper wires, cables, and copper pipes with Jaina Enterprises. Get transparent weighing and immediate, top-market prices."
        keywords="copper scrap, copper wire recycling, copper cable scrap, copper pipe scrap, sell copper scrap"
      />
      <style>{`
        *{
          margin:0;
          padding:0;
          box-sizing:border-box;
          font-family:Arial, Helvetica, sans-serif;
        }

        .hero{
          background:#fff;
          padding:80px 8%;
        }

        .hero-container{
          max-width:1300px;
          margin:auto;
          display:flex;
          align-items:center;
          justify-content:space-between;
          gap:60px;
          flex-wrap:wrap;
        }

        .hero-content{
          flex:1;
          min-width:320px;
        }

        .hero-content span{
          display:inline-block;
          background:#FFF4D6;
          color:#0A2E73;
          padding:8px 18px;
          border-radius:30px;
          font-size:15px;
          font-weight:600;
          margin-bottom:20px;
        }

        .hero-content h1{
          font-size:52px;
          color:#0A2E73;
          line-height:1.2;
          margin-bottom:20px;
        }

        .hero-content p{
          color:#555;
          font-size:17px;
          line-height:1.9;
          margin-bottom:18px;
        }

        .hero-btn{
          display:inline-block;
          margin-top:20px;
          padding:15px 35px;
          background:#0A2E73;
          color:#FFD700;
          text-decoration:none;
          border-radius:40px;
          font-weight:bold;
          transition:.3s;
        }

        .hero-btn:hover{
          background:#FFD700;
          color:#0A2E73;
        }

        .hero-image{
          flex:1;
          min-width:320px;
        }

        .hero-image img{
          width:100%;
          border-radius:20px;
          box-shadow:0 20px 40px rgba(0,0,0,.15);
        }

        @media(max-width:992px){

          .hero-container{
            flex-direction:column-reverse;
            text-align:center;
          }

          .hero-content h1{
            font-size:42px;
          }

        }

        @media(max-width:768px){

          .hero{
            padding:60px 5%;
          }

          .hero-content h1{
            font-size:34px;
          }

          .hero-content p{
            font-size:16px;
          }

          .hero-btn{
            padding:14px 30px;
          }

        }

        @media(max-width:480px){

          .hero-content h1{
            font-size:28px;
          }

          .hero-content p{
            font-size:15px;
          }

        }
      `}</style>

      <section className="hero">

        <div className="hero-container">

          <div className="hero-content">

            <span>Premium Copper Scrap Dealer</span>

            <h1>Buy & Sell Premium Quality Copper Scrap</h1>

            <p>
              We deal in all types of copper scrap including copper wire,
              copper pipes, copper sheets, copper cable scrap, motor scrap,
              and Millberry copper. Our team offers competitive pricing,
              transparent weighing, and fast pickup services.
            </p>

            <p>
              Whether you are an industry, factory, contractor, or trader,
              we provide reliable copper scrap solutions with eco-friendly
              recycling practices and instant payment.
            </p>

            <a href="/contact" className="hero-btn">
              Contact Us
            </a>

          </div>

          <div className="hero-image">

            <img
              src={copperscrap}
              alt="Premium Copper Scrap"
              loading="lazy"
            />

          </div>

        </div>

      </section>

    </>
  );
};

export default CopperHero;